'use client';

import Image from 'next/image';
import { memo } from 'react';
import gemImg from '../../public/assets/gem.webp';
import cardImg from '../../public/assets/card.webp';


interface HeroBannerProps {
  locale?: 'en' | 'si' | 'ta';
}

const HeroBanner = ({ locale = 'en' }: HeroBannerProps) => {

  return (
    <div className="relative bg-background min-h-screen overflow-hidden">
      <section className="relative min-h-screen">
        <div
          className="hero-clip absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse at 46.8% 109%, #BFDEFF 0%, #659EDA 99%)',
          }}
        />

        <div
          className="hero-clip absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(hsla(0,0%,100%,0.15) 1px, transparent 1px), linear-gradient(90deg, hsla(0,0%,100%,0.15) 1px, transparent 1px)',
            backgroundSize: '120px 120px',
          }}
        />

        <div className="hero-clip absolute inset-0 z-[50] pointer-events-none">
          <div className="relative h-full w-full max-w-[1450px] mx-auto pointer-events-none">
            <div
              className="absolute bottom-0 left-[-20%] h-[40%] md:h-[65%] md:left-[-16%] lg:h-[89%] lg:left-[4%] 2xl:left-[-1%]"
              style={{ transform: 'translateY(-3%)' }}
            >
              <Image
                alt="Free Fire Character"
                className="w-auto h-full object-contain"
                src="/assets/joker-main.webp"
                width={800}
                height={1200}
                sizes="(max-width: 768px) 30vw, 20vw"
                quality={75}
                loading="lazy"
              />
            </div>

             <div
               className="absolute bottom-0 right-[-20%] h-[36%] md:h-[60%] md:right-[-30%] lg:h-[80%] lg:right-[3%] 2xl:right-[-2.2%]"
               style={{ transform: 'translateY(-12%)' }}
             >
               <Image
                 alt="Free Fire Character"
                 className="w-auto h-full object-contain"
                 src="/assets/mm.webp"
                 width={800}
                 height={1200}
                 sizes="(max-width: 768px) 30vw, 20vw"
                 quality={75}
                 loading="lazy"
               />
             </div>
          </div>
        </div>

        <div className="absolute pointer-events-none z-[48] md:z-[5] bottom-[10%] left-[10%] md:bottom-auto md:top-[3%] md:left-[34%] md:-translate-x-1/2">
          <div
            className="w-[180px] md:w-[350px] lg:w-[450px]"
          >
             <Image
               src={gemImg}
               alt="Free Fire Diamonds Gem illustration"
               className="w-full h-auto object-contain"
               sizes="(max-width: 767px) 180px, (max-width: 1023px) 350px, 450px"
               priority
               fetchPriority="high"
               decoding="sync"
               unoptimized
             />
          </div>
        </div>

        <div className="absolute z-[52] pointer-events-none bottom-[8%] right-[10%] md:bottom-auto md:top-[32%] md:right-[35%] md:translate-x-1/2">
          <div
            className="w-[200px] md:w-[350px] lg:w-[450px]"
          >
            <Image src={cardImg} alt="Free Fire Weekly Lite and Membership Card illustration" className="w-full h-auto object-contain" sizes="(max-width: 767px) 200px, (max-width: 1023px) 350px, 450px" loading="lazy" />
          </div>
        </div>

        <div className="relative w-full flex items-start pt-36 sm:pt-24 md:items-center md:pt-0 justify-center min-h-screen z-[30]">
          <div className="w-full text-center px-4 flex flex-col items-center">
            <h1
              className={`mt-20 sm:mt-10 md:mt-0 text-center font-display uppercase leading-[0.92] tracking-tight ${locale === 'si' ? 'text-3xl md:text-5xl lg:text-6xl' : locale === 'ta' ? 'text-4xl md:text-6xl lg:text-7xl' : 'text-5xl md:text-9xl lg:text-[6rem]'}`}
              style={{ color: 'white' }}
            >
              <span className="sr-only">Baasil Topup - Cheap Free Fire Diamond Top Up Sri Lanka</span>
              {locale === 'si'
                ? (
                  <>
                    <span className="font-un-davasa tracking-[0.05em] text-4xl lg:text-7xl">ශ්‍රී ලංකාවේ ලාභම හා</span> <span className="tracking-[0.02em]">#1 Free Fire</span>  
                    <br />
                    <span className=" tracking-[0.02em] text-3xl lg:text-6xl ">topup service</span> <span className="font-un-davasa tracking-[0.05em] text-4xl lg:text-7xl">එක</span>
                  </>
                )
                : locale === 'ta'
                  ? (
                    <>
                      Free Fire Diamond Topup
                      <br />
                      இலங்கை
                    </>
                  )
                  : (
                    <>
                      Free Fire Diamond Topup
                      <br />
                      Sri Lanka
                      <br />
                      Instant &amp; Cheapest
                    </>
                  )}
            </h1>
            <p
              className="mt-5 text-[10px] md:text-xs text-center uppercase tracking-[0.1em] max-w-lg mx-auto relative z-[40] font-mono "
              style={{
                color: 'hsla(0, 0%, 100%, 0.65)',
              }}
            >
              {locale === 'si'
                ? 'EzCash, LankaQR, Visa, Mastercard, Amex හෝ Bank Transfer මගින් ගෙවන්න. Password දෙන්න ඕනෑ නැහැ. තත්පරයක් ඇතුළත diamonds ඔබේ account එකට එනවා.'
                : locale === 'ta'
                  ? 'EzCash, LankaQR, Visa, Mastercard, Amex அல்லது Bank Transfer மூலம் செலுத்தவும். கடவுச்சொல் தேவையில்லை. உடனடியாக பெறுங்கள்.'
                  : "Sri Lanka's cheapest Free Fire diamonds - instant delivery, EzCash,Visa,Mastercard,Amex,Bank Transfer & LankaQR accepted."}
            </p>
            <div
              className="mt-6 w-full flex items-center justify-center gap-4 relative z-[60]"
            >
              <button
                onClick={() => {
                  const el = document.getElementById('uid-verify');
                  if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="text-xs uppercase tracking-[0.2em] border rounded-[2px] px-6 py-2.5 transition-colors hover:opacity-80 cursor-pointer"
                style={{
                  borderColor: 'white',
                  color: '#548DC8',
                  backgroundColor: 'white',
                }}
              >
                {locale === 'si' ? 'දැන් Topup කරන්න' : locale === 'ta' ? 'இப்போது Topup செய்யுங்கள்' : 'Top Up Now'}
              </button>
            </div>
          </div>
        </div>

        <div
          aria-hidden="true"
          className="absolute left-1/2 -translate-x-1/2 text-[120px] md:text-[200px] lg:text-[280px] font-display uppercase tracking-[-0.02em] pointer-events-none select-none z-[15] whitespace-nowrap bottom-[30px] md:-bottom-[20px]"
          style={{
            color: 'transparent',
            WebkitTextStroke: '1px hsla(0,0%,100%,0.25)',
          }}
        >
          BAASIL FF
        </div>
      </section>
    </div>
  );
};

export default memo(HeroBanner);
